export const FormSubmit = {
  "formId": "",
  "formName": "",
  "formErrorMessages": "",
  "formAction": "",
  "formStatus": "",
  "pageName": "",
  "pageUrl": "",
  "pageCategory": "",
};